import React from "react";
import { IconWithBackground } from "../../../../ui/components/IconWithBackground";
import { Button } from "../../../../ui/components/Button";
import { Loader } from "../../../../ui/components/Loader";
import { FeatherClock } from "@subframe/core";

interface PendingCardProps {
  title: string;
  count?: number;
  loading?: boolean;
  onViewDetails: () => void;
}

export const PendingCard: React.FC<PendingCardProps> = ({
  title,
  count = 0,
  loading = false,
  onViewDetails,
}) => {
  return (
    <div className="flex grow shrink-0 basis-0 flex-col items-start gap-4 rounded-md border border-solid border-neutral-border bg-default-background px-6 py-6">
      <div className="flex items-center gap-2">
        <IconWithBackground variant="warning" icon={<FeatherClock />} />
        <span className="text-body-bold font-body-bold text-subtext-color">
          {title}
        </span>
      </div>

      <div className="flex w-full items-end justify-between">
        <div className="flex flex-col items-start gap-1">
          <span className="text-body font-body text-subtext-color">Count</span>
          <span className="text-heading-2 font-heading-2 text-default-font">
            {count}
          </span>
        </div>
      </div>

      <Button size="small" onClick={onViewDetails}>
        View Details
      </Button>
    </div>
  );
};

